export default __webpack_public_path__ + "static/media/game-pagetype-results_win_game.acc4942f.svg";